import React from 'react';
import { IconButton, Snackbar, SnackbarContent } from '@material-ui/core';
import { withStyles, WithStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import { AlmeHistoryConfig } from '../AlmeHistory/AlmeHistoryConfig';
import { FocusComponentProps } from '../../models/ComponentProps';
import { AlmeEnvironmentConfig } from '../../api/AlmeEnvironmentConfig';
import timeoutWarningStyles from './AlmeTimeoutWarning.styles';
import { getTextWithConfigs } from '../../utils/ConfigUtils';
import { useIntl } from 'react-intl';
import { useFocusStyles } from '../FocusVisibleStyle';
interface AlmeTimeoutWarningProps extends WithStyles<typeof timeoutWarningStyles> {
    almeConfig: AlmeHistoryConfig;
    shouldDisplayTimeout: boolean;
    focusProps?: FocusComponentProps;
    setShouldDisplayTimeout:(newState:boolean)=> void;
}

const AlmeTimeoutWarning: React.FC<AlmeTimeoutWarningProps> = (props: AlmeTimeoutWarningProps) => {
    const intl = useIntl();
    const Focusclasses = useFocusStyles();
    const config = AlmeEnvironmentConfig.getInstance().getConfig();

    const defaultTime = config.ClientSessionTimeout ?? "20";
    const timeoutValue = defaultTime as string;

    const message = intl.formatMessage({
        id: "timeout.timeoutWarningMessage",
        defaultMessage: 'Default timeout warning message',
        description: 'AlmeTimeoutWarning text',
    });
    const timeoutMessage = getTextWithConfigs([timeoutValue], message);

    const handleTimeoutClose = (event?: React.SyntheticEvent, reason?: string): void => {
        if (reason === 'clickaway') {
            return;
        }

        props.setShouldDisplayTimeout(false);
    };


    if (!props.almeConfig.history.timeout.isEnabled || !props.shouldDisplayTimeout) {
        return null;
    }
    else {
        return (
            <Snackbar
                id='alme-timeout-warning'
                className={props.classes.snackBar}
                open={props.shouldDisplayTimeout}
                autoHideDuration={props?.almeConfig.history.timeout.displayDuration}
                onClose={handleTimeoutClose}
                {...props.focusProps}
            >
                <SnackbarContent
                    id='alme-timeout-warning-content'
                    message={timeoutMessage}
                    aria-label={timeoutMessage}
                    classes={{root:props.classes.snackBarContent,message:props.classes.snackBarMessage}}
                    action={
                        <React.Fragment>
                            <IconButton id="alme-timeout-warning-close" className={Focusclasses.visibleFocus}
                                size="small" aria-label="close" color="inherit" onClick={handleTimeoutClose}>
                                <CloseIcon fontSize="small" />
                            </IconButton>
                        </React.Fragment>
                    }
                />
            </Snackbar>
        );
   }
};

export default withStyles(timeoutWarningStyles)(AlmeTimeoutWarning);
